// eslint-disable-next-line no-shadow
export enum NotificationType {
  Info = 5,
  Warning = 6,
  Error = 7,
  UnKnown = 99,
}

export const notificationIconByType = {
  5: 'message-notifications-info',
  6: 'message-notifications-warning',
  7: 'message-notifications-error',
};
